module.exports = __webpack_public_path__ + "static/img/Nat_Fyfe_mobile.b1ff951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nat_Fyfe_mobile.jpg
// module id = P/dC
// module chunks = 0